export default function BudgetModeStep({ theme: t, value, onChange }) {
  const modes = [
    {
      key: 'standard',
      icon: '\u{1F4CB}',
      title: 'Standard Budgeting',
      desc: 'Set a budget per category and track how much you spend. Simple and flexible.',
    },
    {
      key: 'envelope',
      icon: '\u{2709}\u{FE0F}',
      title: 'Envelope Budgeting',
      desc: 'Assign every dollar of income to a category. Nothing left unallocated. Great for saving goals.',
    },
  ];

  return (
    <div style={{ textAlign: 'center' }}>
      <h2 style={{ fontSize: 20, fontWeight: 800, color: t.text, margin: '0 0 8px' }}>
        Choose Your Budget Style
      </h2>
      <p style={{ fontSize: 13, color: t.textMuted, marginBottom: 20, lineHeight: 1.5 }}>
        You can switch between these anytime in Settings.
      </p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {modes.map((m) => {
          const selected = value === m.key;
          return (
            <button
              key={m.key}
              onClick={() => onChange(m.key)}
              style={{
                background: selected ? (t.bg === '#0f172a' ? '#1e3a5f' : '#eff6ff') : t.cardBg,
                border: '2px solid ' + (selected ? '#2563eb' : t.cardBorder),
                borderRadius: 14,
                padding: 18,
                cursor: 'pointer',
                textAlign: 'left',
                transition: 'border-color 0.2s, background 0.2s',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
                <span style={{ fontSize: 22 }}>{m.icon}</span>
                <span style={{ fontSize: 15, fontWeight: 700, color: t.text }}>{m.title}</span>
                {selected && <span style={{ marginLeft: 'auto', color: '#2563eb', fontWeight: 700, fontSize: 13 }}>{'\u2713'} Selected</span>}
              </div>
              <div style={{ fontSize: 13, color: t.textMuted, lineHeight: 1.5, paddingLeft: 32 }}>
                {m.desc}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
